import { useState, useEffect } from 'react';
import { api } from '../lib/api.ts';
import { SourceTable } from '../components/SourceTable.tsx';
import type { Source } from '../lib/types.ts';

export function SourceMonitor() {
  const [sources, setSources] = useState<Source[]>([]);
  const [loading, setLoading] = useState(true);

  async function load() {
    setLoading(true);
    try {
      const res = await api.sources.list();
      setSources(res.sources);
    } finally {
      setLoading(false);
    }
  }

  useEffect(() => { load(); }, []);

  const active = sources.filter(s => s.active).length;
  const errors = sources.filter(s => s.has_error_today).length;

  return (
    <div>
      <div style={{ display: 'flex', alignItems: 'center', gap: 16, marginBottom: 20 }}>
        <h1 style={{ margin: 0, fontSize: 20 }}>Source Monitor</h1>
        <span style={{ fontSize: 13, color: '#666' }}>{sources.length} sources · {active} active</span>
        {errors > 0 && (
          <span style={{ fontSize: 12, background: '#fde', color: '#c0392b', padding: '2px 8px', borderRadius: 3 }}>
            {errors} error{errors !== 1 ? 's' : ''} today
          </span>
        )}
        <button onClick={load} style={{ marginLeft: 'auto', fontSize: 12, padding: '4px 10px' }}>↻ Refresh</button>
      </div>

      {loading && <p style={{ color: '#999' }}>Loading…</p>}
      {!loading && (
        <div style={{ background: '#fff', border: '1px solid #eee', borderRadius: 6, overflow: 'auto' }}>
          <SourceTable sources={sources} onUpdate={load} />
        </div>
      )}
    </div>
  );
}
